import React, { memo } from 'react';

export const DoorGlassSmall: React.FC = memo(() => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="23" viewBox="0 0 16 23" fill="none">
    <path
      d="M13.0166 3H14.5166C14.7927 3 15.0166 3.22386 15.0166 3.5V19.5C15.0166 19.7761 14.7927 20 14.5166 20H13.0166"
      stroke="#919395"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M1 3.21469C1 2.97265 1.17336 2.76537 1.41159 2.72257L10.4116 1.10571C10.7182 1.05062 11 1.2863 11 1.59783V21.422C11 21.7268 10.7296 21.9606 10.428 21.9167L1.42799 20.6069C1.18225 20.5711 1 20.3604 1 20.1121V3.21469Z"
      fill="white"
      stroke="#21282B"
      strokeWidth="1.25"
    />
    <path d="M9.0166 11L9.0166 11.8708" stroke="#21282B" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M4.37012 2L4.37012 21" stroke="#60A3BD" strokeWidth="3" />
    <path
      d="M1 3.21469C1 2.97265 1.17336 2.76537 1.41159 2.72257L10.4116 1.10571C10.7182 1.05062 11 1.2863 11 1.59783V21.422C11 21.7268 10.7296 21.9606 10.428 21.9167L1.42799 20.6069C1.18225 20.5711 1 20.3604 1 20.1121V3.21469Z"
      stroke="#21282B"
      strokeWidth="1.25"
    />
  </svg>
));
